import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

import { AuthService } from '../auth.service';
import { FormControl, FormGroup } from '@angular/forms';
import { FormControlValidators } from '../models/validators/validator';
import { DataProvider2 } from "../provider/data2.provider";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";

@Component({
	selector: 'sign-in',
	template: `		
		<div class="container">
			<form class="form-signin" [formGroup]="form" (ngSubmit)="onSubmit()">
				<h2 class="form-signin-heading">
					Please sign in
				</h2>
				
				<label for="inputEmail" class="sr-only">Email address</label>
				<input type="email" name="email" class="form-control" formControlName="email">
				<label for="inputPassword" class="sr-only">Password</label>
				<input type="password" name="password" class="form-control" formControlName="password">
				<button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
			</form>
		</div>
	`
})
export class SignInComponent implements OnInit {
	form = new FormGroup({
		email: new FormControl('', [
			FormControlValidators.email(),
			FormControlValidators.required(),
		]),
		password: new FormControl('', [
			FormControlValidators.required(),
		]),
	});
	
	constructor(
		public authService: AuthService,
		public router: Router,
		public dp: DataProvider2,
	) {
		
	}
	
	
	async ngOnInit() {
		await this.authService.fetch();
		
		if (this.authService.isAuth) {
			return this.router.navigate(['/']);
		}
	}
	
	
	onSubmit() {
		
		// Почему-то concat (версия 6.5.2) отрабатывает непоследовательно!
		this.dp.post('/sign_in', this.form.value).pipe(
			switchMap(() =>
				from(
					this.authService.fetch()
				)
			),
			switchMap(() =>
				from(
					this.authService.fetchAllowedResources()
				)
			),
			switchMap(() =>
				from(
					this.router.navigate(['/'])
				)
			),
		).subscribe(() => {
			console.log('go to /');
		})
	}
}
